import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Remonte automatiquement en haut de page à chaque changement d'URL
 * (React Router ne le fait pas par défaut, contrairement à une vraie navigation HTTP).
 */
export const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};
